module.exports = __webpack_public_path__ + "static/media/salud.99d217c7.svg";